import { usePageMeta } from "@/hooks/usePageMeta";

export default function TermsOfServicePage() {
  usePageMeta("Terms of Service", "Vaana BuildLogic Technologies' Terms of Service outline website usage, liability, service agreements, and compliance standards.");
  return (
    <div data-testid="terms-of-service-page" className="pt-20">
      <section className="bg-[#0D72B8] py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-20">
          <h1 className="text-4xl sm:text-5xl font-['Sora'] font-bold text-white">Terms of Service</h1>
          <p className="text-blue-100 mt-4">Last updated: December 2025</p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-20 prose-custom">
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using the website of Vaana BuildLogic Technologies ("Company", "we", "our"), you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website or services.</p>

          <h2>2. Services</h2>
          <p>Vaana BuildLogic Technologies provides information technology services including but not limited to:</p>
          <ul>
            <li>IT Services and Consulting</li>
            <li>ERP Implementation and Support</li>
            <li>Cloud Services and Migration</li>
            <li>IT Infrastructure Design and Management</li>
            <li>Cyber Security Solutions</li>
            <li>Security and Surveillance Systems</li>
            <li>AR/VR Solutions, AI/ML, IoT, Interactive Content, Multimedia Services, and 3D Printing</li>
            <li>AMC/CMC Maintenance Services</li>
            <li>Educational and Skill Development Services</li>
          </ul>
          <p>Specific terms and conditions for individual services will be outlined in separate service agreements.</p>

          <h2>3. Use of Website</h2>
          <p>You agree to use our website only for lawful purposes. You must not:</p>
          <ul>
            <li>Use the website in any way that violates applicable laws or regulations</li>
            <li>Attempt to gain unauthorized access to any part of the website</li>
            <li>Use the website to transmit any harmful, offensive, or illegal material</li>
            <li>Interfere with or disrupt the website's operations or security</li>
            <li>Use automated tools to scrape or extract data from the website</li>
          </ul>

          <h2>4. Intellectual Property</h2>
          <p>All content on this website, including text, graphics, logos, images, software, and other material, is the property of Vaana BuildLogic Technologies or its content providers and is protected by intellectual property laws. You may not reproduce, distribute, modify, or create derivative works without our prior written consent.</p>

          <h2>5. Enquiries and Communications</h2>
          <p>When you submit an enquiry through our contact form, you consent to receive communications from us regarding your enquiry. We will handle your personal information in accordance with our Privacy Policy.</p>

          <h2>6. Service Agreements</h2>
          <p>Engagement of our professional services will be governed by separate service agreements that will include:</p>
          <ul>
            <li>Scope of work and deliverables</li>
            <li>Payment terms and schedules</li>
            <li>Project timelines and milestones</li>
            <li>Warranty and support terms</li>
            <li>Confidentiality obligations</li>
          </ul>

          <h2>7. Limitation of Liability</h2>
          <p>To the fullest extent permitted by law, Vaana BuildLogic Technologies shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or business opportunities, arising out of or in connection with your use of our website or services.</p>

          <h2>8. Disclaimer of Warranties</h2>
          <p>Our website and its content are provided "as is" and "as available" without any warranties of any kind, either express or implied. We do not guarantee that our website will be uninterrupted, secure, or error-free.</p>

          <h2>9. Indemnification</h2>
          <p>You agree to indemnify and hold harmless Vaana BuildLogic Technologies, its officers, directors, employees, and agents from any claims, damages, losses, liabilities, and expenses arising out of your use of our website or violation of these Terms.</p>

          <h2>10. Governing Law</h2>
          <p>These Terms of Service shall be governed by and construed in accordance with the laws of India. Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts in New Delhi, India.</p>

          <h2>11. Modifications</h2>
          <p>We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting on this page. Your continued use of the website after any modifications constitutes acceptance of the updated terms.</p>

          <h2>12. Severability</h2>
          <p>If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions shall continue in full force and effect.</p>

          <h2>13. Contact Information</h2>
          <p>For any questions regarding these Terms of Service, please contact us:</p>
          <ul>
            <li><strong>Email:</strong> info@vaanabuildlogictechnologies.com</li>
            <li><strong>Phone:</strong> +91 9953167073</li>
            <li><strong>Address:</strong> Office No. 7 Ground Floor, Indra Nursery, Near Badarpur Metro Station, New Delhi 110044</li>
          </ul>
        </div>
      </section>
    </div>
  );
}
